/**
 * 지연 청크를 받는 동안의 자리 — 높이를 미리 차지해 내용이 나타날 때 레이아웃이 밀리지 않게 한다(트랙 A, 적대적 검증 경고 ⓒ).
 * 라우트 단위 자리는 AppRouter 의 RouteChunkFallback(전체 화면 스피너)이고, 화면 안의 패널·본문은 이것을 쓴다.
 */
import { Skeleton } from '@mui/material';

export function LazyFallback({ height }: { height: number }) {
  return <Skeleton variant="rounded" height={height} sx={{ width: '100%' }} />;
}
